import React, { Component } from 'react';
import Slider from "react-slick";

const settings = {
  className: "slider",
  infinite: false,
  swipe: false,
  arrows: false,
  dots: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '120px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        centerPadding: '180px'
      }
    }
  ]
}

export default class StoriesSlider extends Component{
  constructor(props) {
    super(props);
    this.state = { currentSlide: props.startIndex };

    this.videosRef = [];
    this.setVideosRef = (video, key) => {
      this.videosRef[key] = video;
    };
  }
  componentDidMount(){
    this.refs.sliderRef.innerSlider.slickGoTo(this.state.currentSlide)
  }

  beforeChange = (oldIndex, index) => {
    this.setState({ currentSlide: index});
    if(this.props.stories[oldIndex].type === 'video'){
      this.videosRef[oldIndex].pause();
    }
    if(this.props.stories[index].type === 'video'){
      this.videosRef[index].play();
    }
  }

  appendDots = dots => (
    <ul className="stories-dots">
      {dots.map((dot, key) => (
        <li key={key} className={`${key <= this.state.currentSlide ? "active" : ""}`}><span /></li>
      ))}
    </ul>
  )

  render(){
    return (
      <div className="stories-slider">
        <Slider 
          ref="sliderRef" 
          {...settings} 
          beforeChange={this.beforeChange} 
          appendDots={this.appendDots} 
          initialSlide={this.state.currentSlide}
        >
          {this.props.stories.map((story, key) => (
          <div 
            key={key} 
            onClick={() => {this.refs.sliderRef.innerSlider.slickGoTo(key)}} 
            className={`
              stories-item 
              ${key === this.state.currentSlide ? "active" : ""} 
              ${(key < this.state.currentSlide - 1 || key > this.state.currentSlide + 1) ? "pointer-events-disabled" : ""}
            `} 
          >
            <div>
              {
                story.type === 'image' 
                ? <img src={story.media} alt=""/>
                : <video muted loop ref={(video) => this.setVideosRef(video, key)}>
                    <source src={story.media} type="video/mp4" />
                  </video>
              }
              <span />
              <section>
                <p>{story.description}</p>
                {!!story.url && <a href={story.url} target="_blank">Ver mais</a>}
              </section>
            </div>
          </div>
          ))}
          <div></div>
          <div></div>
        </Slider>
        <button className="stories-arrows prev" disabled={this.state.currentSlide === 0} onClick={() => this.refs.sliderRef.innerSlider.slickPrev()}>
          <img src={require('../img/arrow-slider-stories.svg')} alt="Seta para esquerda"/>
        </button>
        <button className="stories-arrows next" disabled={this.state.currentSlide + 1 >= this.props.stories.length} onClick={() => this.refs.sliderRef.innerSlider.slickNext()}>
          <img src={require('../img/arrow-slider-stories.svg')} alt="Seta para direita"/>
        </button>
        <button className="btn-close" onClick={() => {this.props.closeStories()}}><img alt="Fechar" src={require('../img/icon-btn-close.svg')}/></button>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/StoriesSlider.js